<template>
  <div>
    <h1 class="has-text-centered has-text-weight-bold title">Upload Document</h1>
    <upload-component :documentId="$route.params.id"></upload-component>
  </div>
</template>
<script>
export default {
  name: 'Upload',
  components: {
    UploadComponent: () => import('@/components/UploadComponent')
  }
};
</script>
